<template> 
	<div class="compare-block compare-text-infor">
		<h4 class="title compare-block-title pdx-3">
			<i class="title-icon title-icon3"></i>融资信息</h4>
	<!-- <div class="compare-view-scroll compare-text-infor"> -->
	<table  border="0" cellspacing="0" cellpadding="0"  width="100%">
			<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">融资次数</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{emptyStr(list.data.financing.number)}}</span>
				</td> 
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">融资金额</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{emptyStr(list.data.financing.amount)}}</span>
				</td> 
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">最新融资轮次</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{emptyStr(list.data.financingRound.rount)}}</span>
				</td> 
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">最新融资时间</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{emptyStr(list.data.financingRound.time)}}</span>
		</td>
				<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
 	<td class="a-compare-company left-sticky">
 		<h5 class="fz16 title pdx-3">最新融资金额</h5>
 	</td>
 	<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
 		<span class="pdx-3">{{emptyStr(list.data.financingRound.amount)}}</span>
 	</td> 
 	<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
	</table>
	<!-- </div> --> 
	</div> 
</template>

<script>
export default {
		name: 'compare-rzxx',
		data(){return{ 
			userdata:{},
		}},
		props:{
			compareList:{type:Array},
			refreshNum:{type:Number,default:1}
		}
		
		
}
</script>

<style>
</style>